import request from '@/utils/request'

export const getBrazilDetail = id =>
  request.get(`/customer-api/bureau-report/query/dnb/brazil/lookup/${id}`)

export const getGlobalDetail = id =>
  request.get(`/customer-api/bureau-report/query/dnb/lookup/${id}`)

export const getGlobalReportDetail = id =>
  request.get(`/customer-api/bureau-report/query/dnb/report/${id}`)

export const getCrmDetail = id =>
  request.get(`/customer-api/bureau-report/query/dnb/crm/lookup/${id}`)

// ckr report
export const getCkrDetail = id =>
  request.get(`/customer-api/bureau-report/query/dnb/brazil/report/${id}`)

// crm report
export const getCrmFinancialReport = id =>
  request.get(
    `/customer-api/bureau-report/query/dnb/crm/financial/report/${id}`,
  )

// save to f
export const saveToFinancial = params =>
  request.post(`/customer-api/bureau-report/save/financial-report`, params)

export const getCurrenyRate = (date, currencyA) =>
  request.get(`/customer-api/customer/${date}/${currencyA}/to/USD`)

export const saveToFinancialByDbGlobal = params =>
  request.post(`/customer-api/bureau-report/save/financial-report-db-global`, params)
